import hero from '../../components/hero'
import animations from '../js/animations'

/******************************************************** Global variables ****************************************************/

var candy_bag_total_price = parseFloat($('.price .amount bdi').clone().children().remove().end().text().trim().replace(',', '.'))

/***************************************** Update cart content from add and remove buttons *********************************/

function get_bg_image_size(el) {
    var imageUrl = $(el).css('background-image').match(/^url\(["']?(.+?)["']?\)$/);
    var dfd = new $.Deferred();

    if (imageUrl) {
        var image = new Image();
        image.onload = dfd.resolve;
        image.onerror = dfd.reject;
        image.src = imageUrl[1];
    } else {
        dfd.reject();
    }

    return dfd.then(function() {
        return { width: this.width, height: this.height };
    });
};

$(document).on('click','.add-to-cart', function() {
    //update cart text on page bottom
    var number_of_candy = parseInt($('#number-of-candy').val());
    update_cart_content($(this), 'add', number_of_candy)

    var elem = $(this).parent().siblings('.content').find('.candy')
    get_bg_image_size( elem )
    .then(function(size) {
        var height = elem.height()
        if( size.height < size.width ) {
            height = height * ( size.height / size.width )
        }
        elem.animate({
            'backgroundPositionY': '+=' + height
        }, 200 )
    })
})

$(document).on('click','.remove-from-cart', function() {
    //update cart text on page bottom
    var number_of_candy = parseInt($('#number-of-candy').val());
    update_cart_content($(this), 'remove', number_of_candy)

    var elem = $(this).parent().siblings('.content').find('.candy')
    get_bg_image_size( elem )
    .then(function(size) {
        var height = elem.height()
        if( size.height < size.width ) {
            height = height * ( size.height / size.width )
        }
        elem.animate({
            'backgroundPositionY': '-=' + height
        }, 200 )
    })
})

//count product price and weight
function update_cart_content(button, action, number_of_candy) {
    //var totalPrice = parseFloat($('.price .amount bdi').clone().children().remove().end().text().trim().replace(',', '.'))
    var totalPrice = candy_bag_total_price
    var totalWeight = parseInt($('.cart-contents .weight_amount').text().trim())
    var totalAmount = parseInt( $('.candy-amount span').text() )
    var weight_of_candy = button.attr('weight')
    var number = parseInt(button.siblings('.amount').text())
    var price = button.attr('price')
    var product_id = button.attr('product_id')
    var match = document.cookie.match(new RegExp('(^| )' + 'candy_in_bag' + '=([^;]+)'))
    
    var product_index = -1;
    if( match ) { 
        match = JSON.parse(match[2]) 
        if(match) {
            for(var i = 0; i < match.length; i++) {
                if(match[i][0] == parseInt(product_id)) {
                  product_index = i;
                }
             }   
        }
    }

    if (action == 'remove') {
        if(number > number_of_candy) { 
            number -= number_of_candy
            totalAmount = totalAmount - number_of_candy
            if(totalWeight >= weight_of_candy) { totalWeight = totalWeight - parseInt(weight_of_candy) * number_of_candy } 
            else { totalWeight = 0 }
            if(totalPrice > 0) { totalPrice = totalPrice - parseFloat(price) * number_of_candy }
            else { totalPrice = 0.00 }
            //update quantity
            if(product_index > -1) {
                match[product_index][1] = number
                document.cookie = 'candy_in_bag=' + JSON.stringify(match) + ';  path=/'
            }
        } else {
            if(totalWeight >= weight_of_candy) { totalWeight = totalWeight - parseInt(weight_of_candy) * number } 
            else { totalWeight = 0 }
            if(totalPrice > 0) { totalPrice = totalPrice - parseFloat(price) * number }
            else { totalPrice = 0.00 }
            if(number > 0) { totalAmount = totalAmount - number }
            number = 0;
            //cookies remove
            if (product_index > -1) {
                match.splice(product_index);
            }
            document.cookie = 'candy_in_bag=' + JSON.stringify(match) + ';  path=/'
            if($('#show-chosen-products-ajax').find(button).length == 1) {
                button.parent().parent().remove()
            }
        }
    } else {
        totalWeight = totalWeight + parseInt(weight_of_candy) * number_of_candy
        totalPrice = totalPrice + parseFloat(price) * number_of_candy
        totalAmount = totalAmount + parseInt(number_of_candy)
        var old_number = number
        number += number_of_candy
        if( old_number == 0 ) {
            //add to cookies
            var candy = [product_id, number]
            if( match ) {
                match.push(candy)
                document.cookie = 'candy_in_bag=' + JSON.stringify(match) + ';  path=/'
            } else {
                document.cookie = 'candy_in_bag=[' + JSON.stringify(candy) + '];  path=/'
            }
        } else {
            //update quantity
            if( product_index > -1 ) {
                match[product_index][1] = number
                document.cookie = 'candy_in_bag=' + JSON.stringify(match) + ';  path=/'
            }
        }
    }
    $('.weight_amount').text(totalWeight)
    $('.candy-amount span').text(parseInt(totalAmount))
    $('input[name=weight]').val(totalWeight)
    document.cookie = 'current_item_weight=' + totalWeight + ';  path=/'

    candy_bag_total_price = totalPrice
    totalPrice = roundToTwo(totalPrice)
    var currencySymbol = $('.price .woocommerce-Price-currencySymbol').outerHTML()
    $('.price .amount bdi').html(totalPrice.toFixed(2).replace('.', ',') + '&nbsp;' + currencySymbol) 
    $('.count button[product_id=' + product_id + ']').parent().siblings('.quantity').children('.qty').val(number)
    $('.count button[product_id=' + product_id + ']').siblings('.amount').text(number)

    if(totalWeight == 0) {
        $('.add-candy-bag-name').addClass('disabled')
    } else {
        $('.add-candy-bag-name').removeClass('disabled')
    }
}

/**************************************************** Update candy filter ************************************************/

//change cookie value when number of candy updated (the number that user add or remove candys )
$("#number-of-candy").on("input", function() {
    document.cookie = 'number_of_candy=' + $(this).val() + ';  path=/'
});

//show candy by category
$(document).on('click', '.cat-button', function() {
    var checked_cat = $(this).attr('name')
    var url = window.location.href;    
    var cat_id = $(this).attr('id')

    hero.init()

    if( $(this).attr('active') == 'true' ) {
        $(this).attr('active', 'false')
    } else {
        $(this).attr('active', 'true')
    }

    var checked_cats_exists = false
    $('.cat-button').each( function() {
        if($(this).attr('active') == 'true' && $(this).attr('name') != checked_cat) {
            checked_cats_exists = true
        }
    })

    if($(this).attr('active') == 'true') {
        if(checked_cats_exists == false) {
            $('.woocommerce-grouped-product-list-item').hide()
        }
        $('.woocommerce-grouped-product-list-item.' + checked_cat).show()

        var param = { cats: [cat_id] }
        if(url.indexOf('?') > -1) {
            url += '&' + decodeURIComponent($.param(param, true))
        } else {
            url += '?' + decodeURIComponent($.param(param, true))
        }
    } else {
        if( checked_cats_exists == true ) {
            $('.woocommerce-grouped-product-list-item.' + checked_cat).each( function() {
                var product = $(this)
                var show = false
                $('.cat-button[active=true]').each( function() {
                    if( product.hasClass( $(this).attr('name') ) && checked_cat !== $(this).attr('name') ) {
                        show = true
                    }
                })
                if( show == false ) {
                    product.hide()
                }
            })
            if (url.indexOf('?cats=' + cat_id) > -1) {
                url = url.replaceAll( '?cats=' + cat_id + '&', "?");
            } else if (url.indexOf('cats') > -1) {
                var reg = new RegExp('&cats=' + cat_id )
                url = url.replace( reg, "");
            }
        } else {
            $('.woocommerce-grouped-product-list-item').show()
            if (url.indexOf('cats') > -1) {
                url = url.replaceAll(/[&?]cats=([^&]$|[^&]*)/g, "");
            }
        }
    }
    window.history.replaceState(null, null, url);
});

$(document).on('click', '#all-candy', function() {

    $('.woocommerce-grouped-product-list-item').attr('active', 'false')
    $('.woocommerce-grouped-product-list-item').show()

    var url = window.location.href;

    if (url.indexOf('cats') > -1) {
        var url = url.replaceAll(/[&?]cats=([^&]$|[^&]*)/g, "");
        window.history.replaceState(null, null, url);
    }

    hero.init()

})

/**************************************************** Show chosen candy bag ************************************************/

$('.show-chosen-products-button').click( function() {
    var match = document.cookie.match(new RegExp('(^| )' + 'candy_in_bag' + '=([^;]+)'))
    if (match) {
        load_chosen_candy()
        $(this).addClass('clicked')
    }
}) 
function load_chosen_candy() {
    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        async: false,
        data: {
            'action': 'show_chosen_candy',
        },
        success: function(data){
            if(data) {
                $("#show-chosen-products-ajax").show()
                $("#show-chosen-products-ajax").html(data);
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
        }

    });
    return false;
}

$(document).on( 'click', '#show-chosen-products-ajax', function() {
    $('.show-chosen-products-button').removeClass('clicked')
})

/**************************************************** Random candy bag ************************************************/
$('#random').click( function() {
    $('.random.popup').show()
})

/*$("#random-price").bind('mouseup change', function () {
    var new_val = parseFloat($(this).val()).toFixed(1) + 0
    $(this).val(new_val)
 });*/

$('#count-random').click( function() {
    $('.random.popup').hide()
    $('#reset').click()

    var total_price = parseFloat($('#random-price').val())

    var min_price = 1.00

    $('.woocommerce-grouped-product-list-item:visible').each( function() {
        var product_price = parseFloat($(this).find('.count .add-to-cart').attr('price'))
        if( product_price < min_price ) {
            min_price = product_price
        }
    })


    var len = $('.woocommerce-grouped-product-list-item:visible').length
    if(total_price) {
        while( candy_bag_total_price <= total_price - min_price ) {
            console.log(candy_bag_total_price)
            var random = Math.floor( Math.random() * len );
            var random_product = $('.woocommerce-grouped-product-list-item:visible').eq(random)
            var product_price = parseFloat(random_product.find('.count .add-to-cart').attr('price'))
            if( product_price <= ( total_price - candy_bag_total_price ) ) {
                var random_number = Math.floor(Math.random() * 5) + 1;
                var random_total = random_number * product_price;
                while( random_total > ( total_price - candy_bag_total_price ) ) {
                    random_number = Math.floor(Math.random() * 5) + 1;
                    random_total = random_number * product_price;
                }
                update_cart_content(random_product.find('.add-to-cart'), 'add', random_number)
            }
       }
    }
})

/**************************************************** Reset chosen candy ************************************************/

$('#reset').click( function() {
    document.cookie = "candy_in_bag=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    $('.qty').each( function( index) {
        $(this).val(0)
    })
    $('.count .amount').each( function( index) {
        $(this).text(0)
    })
    candy_bag_total_price = 0
    var totalWeight = 0
    $('.weight_amount').text(totalWeight)
    $('input[name=weight]').val(totalWeight)
    document.cookie = "current_item_weight=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    var currencySymbol = $('.price .woocommerce-Price-currencySymbol').outerHTML()
    var totalPrice = 0.00
    $('.price .amount bdi').html(totalPrice.toFixed(2).replace('.', ',') + '&nbsp;' + currencySymbol) 

    $('.add-candy-bag-name').addClass('disabled')

    $('.candy-amount span').text(0)

})

/**************************************************** Save user candy bag ************************************************/

$('#save_candy_bag_button').click( function() {
    $('.save-chosen-candy-bag').show()
    $(this).addClass('clicked')
})

$('.save_candy_bag').click( function() {

    if( $(this).parent().hasClass('save-chosen-candy-bag') ) {
        var name = $('#candy-bag-name').val()
    } else {
        var name = $('#add-to-cart-candy-bag-name').val()
    }

    var weight = $('.weight .weight_amount').text()
    var match = document.cookie.match(new RegExp('(^| )' + 'candy_in_bag' + '=([^;]+)'))
    
    if( match ) { 
        var children = match[2]
        $(this).text('Tallennetaan...')
        save_candy_bag(name, weight, children, $(this))
    }
})

$('.save-chosen-candy-bag .close-popup').click( function() {
    $('#save_candy_bag_button').removeClass('clicked')
})

$(document).on( 'click', '.popup.notification .close-popup', function() {
    $('#save_candy_bag_button').removeClass('clicked')
})

 function save_candy_bag(name, weight, children, button) {
    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        data: {
            'action': 'save_candy_bag',
            'name': name,
            'weight': weight,
            'children': children
        },
        success: function(data){
            if( data != false ) {
                $('.save-chosen-candy-bag').hide()
                button.removeClass('clicked')
                button.text('Tallennettu')
            } else {
                button.after('<p class="error-message">Tämän niminen karkkipussi on jo tallennettu. Anna toinen nimi.</p>')
                button.text('Tallenna')
            }

        },
        error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
        }

    });
    return false;
}

//save candy bag login & register buttons
$('.candy .woocommerce-form-login__submit').click( function() {
    document.cookie = 'open_save_candy_popup=true;  path=/'
})

$('.candy .woocommerce-form-register__submit').click( function() {
    document.cookie = 'open_save_candy_popup=true;  path=/'
})

//on users saved candy bag, if namimaatti is different than current one
$('.change-namimaatti-button').click( function() {
    $('.popup.change-namimaatti').show()
})

$('button.change-namimaatti').click( function() {
    var namimaatti = $(this).attr('namimaatti')
    document.cookie = 'namimaatti=' + namimaatti + ';  path=/'
    document.cookie = 'clear_cart=1;  path=/'
})

/**************************************************** Remove user candy bag ************************************************/

$('.remove_saved_candy_bag').click(function() {
    if (!confirm('Haluatko varmasti poistaa karkkipussin?')) {
        return;
    }

    var id = $(this).attr('candy_id');
    $(this).parent().addClass('removing');
    animations.loadingAnimation('removing');
    remove_candy_bag(id, $(this));
});


function remove_candy_bag(id, button) {
    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        data: {
            'action': 'remove_candy_bag',
            'candy_bag_id': id
        },
        success: function(data){
            button.parents('.candy_bag').remove()
        },
        error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
        }

    });
    return false;
}

/**************************************************** Show user candy bag ************************************************/

$('.show-saved-candy-bag-items').click( function() {
    var id = $(this).attr('candy_bag_id')
    var parent = $(this).parent()
    if( $('.users-candy-bag-products[candy_bag_id=' + id + ']').is(':visible') ) {
        $('.users-candy-bag-products[candy_bag_id=' + id + ']').slideToggle( 400, function() {
            parent.removeClass('open')
        })
    } else {
        parent.addClass('open')
        $('.users-candy-bag-products[candy_bag_id=' + id + ']').slideToggle()
    }
})

/**************************************************** Edit user candy bag ************************************************/

$('.save_edited_candy_bag').click( function(e) {
    e.preventDefault();
 
    var urlParams = new URLSearchParams(window.location.search);
    var candy_bag_id = urlParams.get('edit_saved_candy_bag');

    if( candy_bag_id ) { 
        var candy_bag_children = document.cookie.match(new RegExp('(^| )' + 'candy_in_bag' + '=([^;]+)'))
        if( candy_bag_children ) { 
            var children = candy_bag_children[2]
            var weight = $('.weight .weight_amount').text()
            update_candy_bag(candy_bag_id, weight, children)
        }
    }
    document.cookie = "candy_in_bag=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "current_item_weight=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    window.location.href = $(this).attr('href')
})

function update_candy_bag(candy_bag_id, weight, children) {
    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        data: {
            'action': 'update_candy_bag',
            'candy_bag_id': candy_bag_id,
            'weight': weight,
            'children': children
        },
        success: function(data){
        },
        error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
        }

    });
    return false;
}
/********************************************************* Add candy bag name ********************************************************/

$('.add-candy-bag-name').click( function(e) {
    e.preventDefault();
    if( $('body').hasClass('is-namimaatti-display') ) {
        $('.popup.name-candy-bag .single_add_to_cart_button').click()
    } else {
        if( ! $(this).hasClass('disabled')) {
            $('.popup.name-candy-bag').show()
        }
    }
})

/********************************************************* Show candy info ********************************************************/

$(document).on('click', '.woocommerce-grouped-product-list .info-button', function() {
    var content = $(this).siblings('.info-content').html()
    $('.popup.product-info .content').html(content)
    $('.popup.product-info').show()
})

/********************************************************* Update cart count ********************************************************/
$(document).ready( function() {
    function updateCartCount() {
		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: 'get_cart_count'
			},
			success: function(response) {
				$('.cart-contents-count').remove(); // remove old count if any
				if (parseInt(response) > 0) {
					$('.open-side-cart').append('<span class="cart-contents-count">' + response + '</span>');
				}
			}
		});
	}

	// On add to cart (uses event delegated from WooCommerce)
	$(document.body).on('added_to_cart', function() {
		updateCartCount();
	});
})

/********************************************************* Round to two ********************************************************/

function roundToTwo(num) {    
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    var number = Math.round(m) / 100 * Math.sign(num);
    return number;
}